import type { ComponentProps, PropsWithChildren, ReactNode } from "react";
import {
	Dialog as AriaDialog,
	Modal as AriaModal,
	ModalOverlay as AriaModalOverlay,
} from "react-aria-components";
import { cnBase } from "tailwind-variants";

import { Button } from "@/components/button";
import { Close } from "@/components/icons/close";

type Props = PropsWithChildren &
	Pick<ComponentProps<typeof AriaModalOverlay>, "onOpenChange"> & {
		className?: string;
		title?: ReactNode;
		subtitle?: ReactNode;
	};

export function Dialog({
	children,
	className,
	title,
	subtitle,
	...props
}: Props) {
	return (
		<AriaModalOverlay
			{...props}
			isDismissable
			className="fixed inset-0 backdrop-blur-sm flex justify-center items-center"
		>
			<AriaModal className="max-w-page">
				<AriaDialog
					className={cnBase(
						"max-h-[75vh] min-h-0 relative w-full rounded-6 bg-background inset-shadow-glow shadow-glow border p-9 flex flex-col gap-9",
						className,
					)}
				>
					<Button
						slot="close"
						variant="outline"
						size="round"
						className="absolute top-4 right-4 size-10 rounded-full"
					>
						<Close className="size-4" aria-hidden="true" />
					</Button>
					{title ? (
						<div className="">
							<h1 className="text-28 font-600 mb-1.5">{title}</h1>
							{subtitle ? (
								<h1 className="text-muted-foreground">{subtitle}</h1>
							) : null}
						</div>
					) : null}
					{children}
				</AriaDialog>
			</AriaModal>
		</AriaModalOverlay>
	);
}
